"use client";

import { useMutation } from "@tanstack/react-query";
import { uploadFile } from "../api/uploads";
import type { UploadScope } from "@theta/api-client";

/**
 * Upload one file with its scope declared (§1.11).
 *
 * `type: "avatar" | "composer"` is gone: it described what the UPLOADER was
 * doing, and the server needed to know who may READ the result. `scope` is the
 * second question, and it is the one an ACL can be built from.
 */
export function useUpload() {
  return useMutation({
    mutationFn: ({ file, scope }: { file: File; scope: UploadScope }) =>
      uploadFile(file, { scope }),
  });
}
